'use client';

import React, { useMemo } from 'react';
import { LeadTableComponent } from './lead-table';
import { mergeInventoryTrackingColumns } from '@/lib/inventory/shipmentTracking';
import { resolveInventoryTableDisplayTitle } from './lead-table/utils';

interface RecordsTableProps {
  /**
   * Fully generic config forwarded to LeadTableComponent.
   * Set apiEndpoint, columns, filters, entityType, etc. from PageBuilder.
   */
  config?: any;
}

/**
 * Generic records table component for PageBuilder.
 * Backed by LeadTableComponent but not tied to any specific entity.
 *
 * For inventory_request / unmannd_request tables:
 * - shipment tracking columns are merged when missing
 * - row click opens the form modal so built-in Approve / Reject / Order show
 *   (same as Procurement Table / Manager All Requests)
 */
export const InventoryTableComponent: React.FC<RecordsTableProps> = ({ config }) => {
  const entityType = String(config?.entityType || '').trim();
  const isInventoryRequest =
    entityType === 'inventory_request' || entityType === 'unmannd_request';
  const columns = isInventoryRequest
    ? mergeInventoryTrackingColumns(config?.columns)
    : config?.columns;

  const detailMode = config?.detailMode;
  const keepSpecial =
    detailMode === 'inventory_payment_modal' ||
    detailMode === 'receive_shipments' ||
    detailMode === 'lead_assignment_modal' ||
    detailMode === 'none';

  const mergedConfig = {
    ...(config || {}),
    inventoryTableKind: 'inventory',
    title:
      resolveInventoryTableDisplayTitle({
        configuredTitle: config?.title,
        inventoryTableKind: 'inventory',
        pageDisplayName: config?.pageDisplayName,
      }) || '',
    ...(columns ? { columns } : {}),
    ...(isInventoryRequest && !keepSpecial ? { detailMode: 'record_form_modal' } : {}),
  };

  return <LeadTableComponent config={mergedConfig} />;
};
